import { useContext } from 'react';
import { SearchContext, SearchContextType } from 'utils/root-wrapper';

export const useSearch = (): SearchContextType => {
  return useContext(SearchContext);
};
